import compact from 'lodash/compact';

import {
  GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_additional_item_list as AdditionalItemList,
  PdpCatalogItemDisplayStatus,
  PdpCatalogSalesStatus,
} from '../../graphql/select-option_types.2';
import { CustomOptionsInfo, CustomProductOptionList, CustomTextOption, SelectedOption } from '../../types/option-type';

function mergeOptionsByIteration<T>(options: T[], iterationCount?: number | null): T[][] {
  if (iterationCount && iterationCount > 0) {
    return Array(iterationCount + 1).fill(options);
  }

  return [options];
}

export const initActiveIndex = ({ custom_input_option_list, product_option_list }: CustomOptionsInfo) => {
  if (!custom_input_option_list.length || !product_option_list.length) {
    return 0;
  }

  return custom_input_option_list.length ? -1 : 0;
};

export const initTextOptions = (
  { custom_input_option_list }: CustomOptionsInfo,
  bogo_required_quantity: number | null,
) => {
  const options = custom_input_option_list
    .map((o) => ({ ...o, selected_value: '' }))
    .sort((cur, next) => Number(cur.is_required) - Number(next.is_required)) as CustomTextOption[];

  return mergeOptionsByIteration(options, bogo_required_quantity);
};

export const initAdditionalOptions = ({ product_additional_option_list, additional_item_list }: CustomOptionsInfo) => {
  const items = product_additional_option_list ? product_additional_option_list.slice(0, 1) : [];
  const getItemList = (id: string, additional_item_list: AdditionalItemList[]) => {
    return compact(
      additional_item_list
        .filter((item) => item.display_status === PdpCatalogItemDisplayStatus.VISIBLE)
        .map((item) => {
          if (item.item_attribute_list.length === 0) {
            return null;
          }

          const { name, value } = item.item_attribute_list[0];
          const refined_name = `${name} ${value}`;
          return {
            ...item,
            name: refined_name,
            value: refined_name,
            sold_out: item.sales_status !== PdpCatalogSalesStatus.ON_SALE,
          };
        }),
    );
  };

  return items.map((data) => ({
    ...data,
    item_list: additional_item_list ? getItemList(data.id, additional_item_list) : [],
  }));
};

export const initOptions = (
  product_item_attribute_list: CustomProductOptionList[],
  bogo_required_quantity: number | null,
) => {
  const options = product_item_attribute_list.map((option) => ({
    ...option,
    selected_value: '',
    selected_value_id: '',
    is_zigzin: false,
  })) as SelectedOption[];

  return mergeOptionsByIteration(options, bogo_required_quantity);
};
